import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { memo } from 'react';
import { FaCheck } from 'react-icons/fa';
import ToolTip from './ToolTip/ToolTip';
const styles = css `
  background-color: transparent;
  border: none;
  height: 100%;

  svg {
    fill: green;
    font-size: 16px;
  }
`;
function SaveButton(props) {
    const { className = '', disabled = false, popupPlacement = 'left', popupTitle = 'Save', onClick, } = props;
    return (_jsx("div", { className: className, children: _jsx(ToolTip, { title: popupTitle, popupPlacement: popupPlacement, children: _jsx("button", { css: styles, type: "button", onClick: onClick, disabled: disabled, className: className, children: _jsx(FaCheck, {}) }) }) }));
}
export default memo(SaveButton);
